import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Unauthorised" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "top-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "table-container" }, null, -1)

import { onMounted } from "vue";
// Services
import { AuthorisationLevel } from "@/config/AuthConfig";
import { authService } from "@/auth/authSingleton";
import { LocationQuery, LocationQueryValue, RouteRecordRaw, useRoute } from "vue-router";
// Misc
import { routes } from "@/router/index"
import ErrorInfo from "@/components/ErrorInfo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Unauthorised',
  setup(__props) {

onMounted(() => {
    document.title = 'Unauthorised - UV'
});

// ROUTE
const route = useRoute();
const locationQuery: LocationQuery = route.query;
const locationQueryValue: LocationQueryValue | LocationQueryValue[] = locationQuery.redirect;
const accessAttempt: string | undefined = !locationQueryValue ?  route.path : toTitleCase(
    locationQueryValue?.toString()
        ?.replace("/", "")
        ?.replace("/", " ")
        ?.replaceAll("-", " ")
        ?.split("/")
        ?.shift()
);
const requiredAuthLevel = routes.find((route: RouteRecordRaw) => route.path === locationQueryValue?.toString().split("/").slice(0, 2).join("/") )?.meta?.authLevel;

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        .replace("And", "and")
        .replace("Eop", "EoP");
    }
  );
}

// ERRORS
const UnauthorisedErrorInfo = ErrorInfo;
const errorDisplayText: string = `You do not have the correct permissions to access ${accessAttempt}.`
const errorDetails: string = `(Unauthorised) Your authorisation level is ${AuthorisationLevel[authService.getUsersRole()]} (${authService.getUsersRole()}), however this page requires an authorisation level of ${requiredAuthLevel ?? AuthorisationLevel.Maintenance}.
    \nPlease seek assistance from the help desk or try logging in with a different account.`

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(UnauthorisedErrorInfo), {
          showError: true,
          errorDescription: errorDetails,
          errorDisplayText: errorDisplayText,
          errorMessage: errorDetails
        })
      ]),
      _hoisted_4
    ])
  ]))
}
}

})